import React from 'react';
import { A } from 'hookrouter';
import Form from 'react-bootstrap/Form';
import { useInput } from 'hooks';
import './styles/commonForm.scss';
import { FormButton } from '../common';

const SigninForm = ({ title, signUpPath, isNewUser, signIn }) => {
  const requiredFields = ['login', 'password'];
  const { inputs, handleInputChange } = useInput();

  return (
    <div className="occu-form">
      <h4>{title}</h4>

      <Form
        onSubmit={(event) => {
          signIn(inputs.login, inputs.password);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formUsername">
          <Form.Label>Username</Form.Label>
          <Form.Control type="text" name="login" onChange={handleInputChange} value={inputs.login} required />
        </Form.Group>

        <Form.Group controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            name="password"
            onChange={handleInputChange}
            value={inputs.password}
            minLength={8}
            maxLength={30}
            required
            autoComplete="off"
          />
        </Form.Group>

        <FormButton requiredFields={requiredFields} submittedFields={inputs} />

        <Form.Group controlId="form-links">
          {isNewUser && (
            <Form.Text className="form-link">
              <A href={signUpPath}>New Enrollment</A>
            </Form.Text>
          )}
          <Form.Text className="form-link">
            <A href="forgot-credentials">Forgot Username or Password?</A>
          </Form.Text>
        </Form.Group>
      </Form>
    </div>
  );
};

export { SigninForm };
